import axios from 'axios'
const i18nUrl = 'https://ard-static.flashexpress.com/flm-flp-wallet-id-ui/lang/'
// 获取json文件
export const getJson = function (lang) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: i18nUrl + lang + `.json?timer=${new Date().getTime()}`,
      dataType: 'json'
    }).then(res => {
      resolve(res)
    }).catch(error => {
      console.log(error)
      reject(error)
    })
  })
}
